import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledLoadingState = styled(Box, {
  shouldForwardProp: prop => prop !== 'minHeight',
})<{ minHeight?: number | string }>(({ theme, minHeight }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  justifyContent: 'center',
  minHeight: minHeight ?? 220,
  textAlign: 'center',
  width: '100%',
}));

export const StyledLoadingLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  maxWidth: 320,
}));
